import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-bg-warning p-3 fw-700"
}
const _hoisted_2 = { class: "mb-3" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("i", { class: "mas me-1 fs-6" }, "mail", -1)
const _hoisted_5 = {
  key: 1,
  class: "text-bg-warning p-3 fw-700"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-auto" }
const _hoisted_9 = {
  key: 0,
  class: "row"
}
const _hoisted_10 = { class: "col-auto" }
const _hoisted_11 = { class: "alert alert-warning fw-700 mb-3 d-flex align-items-center" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "mas me-2 fs-5" }, "warning", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSpinner = _resolveComponent("BaseSpinner")!
  const _component_InputSelect = _resolveComponent("InputSelect")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseSpinner, {
      spin: !this.isReady
    }, null, 8, ["spin"]),
    (this.isReady && !this.hasLicense)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.$t('cms.careCalendar_noLicense')), 1),
          _createElementVNode("a", {
            class: "btn btn-primary btn-sm",
            href: this.requestLicenseMailToLink
          }, [
            _hoisted_4,
            _createTextVNode(_toDisplayString(_ctx.$t('cms.careCalendar_requestLicense')), 1)
          ], 8, _hoisted_3)
        ]))
      : _createCommentVNode("", true),
    (this.isReady && this.hasLicense && !this.hasSelectableWidgets)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$t('cms.careCalendar_noSelectableWidgets')), 1))
      : _createCommentVNode("", true),
    (this.isReady && this.hasLicense && this.hasSelectableWidgets)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_InputSelect, {
                name: "widget_code",
                label: _ctx.$t('cms.careCalendar_widget'),
                selectText: _ctx.$t('selectText'),
                modelValue: this.contentBlock.widget_code,
                "onUpdate:modelValue": [
                  _cache[0] || (_cache[0] = ($event: any) => ((this.contentBlock.widget_code) = $event)),
                  this.onChange
                ],
                options: this.widgetOptions,
                rules: "required",
                errors: _ctx.errors
              }, null, 8, ["label", "selectText", "modelValue", "options", "errors", "onUpdate:modelValue"])
            ])
          ]),
          (this.isSelectionUnresolved)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('cms.careCalendar_unresolvedWidget', {widgetCode: this.contentBlock.widget_code})), 1)
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ], 64))
}